<template>
  <div class="w-full h-full relative">
    <div class="act-input-placeholder" v-if="placeholder && !this.isFocus && model === null" @click="focusInput">{{placeholder}}</div>

    <vs-input
            :value="model"
            @keypress="validateInput($event, type)"
            :class="inputClass"
            :danger="hasErrors"
            @change="model = $event.target.value"
            :disabled="disabled"
            ref="input"
            class="validation-input"
            @focus="onFocus(true)"
            @blur="onFocus(false)"
    />
    <transition name="fade">
      <div v-if="hasErrors" class="validation-input-error">
        {{firstErrorMessage}}
      </div>
    </transition>
  </div>

</template>

<script>
  import { singleErrorExtractorMixin } from "vuelidate-error-extractor";
  export default {
    name: "Input",
    mixins: [singleErrorExtractorMixin],
    props: {
      value: {
        type: [Object, String, Number],
        default: null
      },
      type: {
        default: 'text'
      },
      inputClass: {},
      disabled: {
        type: Boolean,
        default: false,
      },
      placeholder: {

      }
    },
    data(){
      return {
        isFocus: false,
      }
    },
    computed: {
      model : {
        get () {
          return this.value
        },
        set (v) {
          let value = this.getTypedValue(v);
          this.$emit('input', value);
          this.validator.$touch()
        }
      },
    },
    methods: {
      onFocus(isFocus){
        this.isFocus = isFocus;
      },
      validateInput(e, type = 'text'){
        let keyCode = e.which ? e.which : e.keyCode;

        if(type === 'double'){
          if(!((keyCode >= 48 && keyCode <= 57) || keyCode === 46 || keyCode === 44 || keyCode === 45)){
            e.preventDefault();
          }
        }
        else if(type === 'int'){
          if(!((keyCode >= 48 && keyCode <= 57) || keyCode === 45)){
            e.preventDefault();
          }
        }
      },
      getTypedValue(v){
        let value = v;

        if(['int', 'double'].includes(this.type)){
          if(value === null || value === ''){
            value = null;
          }
          else{
            let valueTemp = Number(String(value).replace(/,/g, '.'));
            if(!isNaN(valueTemp) && isFinite(valueTemp)){
              value = valueTemp
            }
          }
        }

        return value;
      },
      focusInput(){
        this.$refs.input.focusInput();
      }
    },
    mounted() {},

  }
</script>

<style lang="scss">
  .act-input-placeholder{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    vertical-align: middle;
    display: flex;
    align-items: center;
    /* justify-content: center; */
    font-size: 12px;
    color: rgba(0,0,0,.2);
    padding: .5rem 1rem;
  }
</style>